import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
    return (
        <>
            <Helmet>
                <title>Privacy Policy | Bliss Water Technology</title>
                <meta
                    name="description"
                    content="Bliss Water Technology's privacy policy outlines how we collect, use, and protect your data when you purchase or service water filters, geysers, pumps, and membranes."
                />
                <meta
                    name="keywords"
                    content="Privacy Policy, data protection, Bliss Water Technology, customer privacy, water filter data use, pump service privacy, membrane installation information"
                />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <HeadingNavbar />
            <Header />
            <Container>
                <Row className="my-md-5 my-4">
                    <Col>
                        <Card.Title className="text-center fs-2 mb-3 fw-bold">
                            Privacy Policy
                        </Card.Title>
                        <Card>
                            <Card.Body>
                                <Card.Text as="div">
                                    <section>
                                        <h5 className="fw-bold">Introduction</h5>
                                        <p>
                                            At <strong>Bliss Water Technology</strong>, we are
                                            committed to protecting your privacy. This Privacy Policy
                                            outlines how we collect, use, and secure your personal
                                            information when you use our services for purchasing,
                                            installing, or servicing water filters, geysers, pumps,
                                            and membranes.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Information We Collect</h5>
                                        <p>We may collect the following personal information:</p>
                                        <ul>
                                            <li>Your name and phone number</li>
                                            <li>Billing and service address</li>
                                            <li>Preferred date/time for delivery or installation</li>
                                            <li>Technical data via cookies and usage analytics</li>
                                        </ul>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">How We Use Your Information</h5>
                                        <p>Your data may be used to:</p>
                                        <ul>
                                            <li>Process product purchases and coordinate delivery</li>
                                            <li>Schedule installations and service visits</li>
                                            <li>Communicate order status and service updates</li>
                                            <li>Respond to support requests and inquiries</li>
                                            <li>
                                                Send optional promotions or service reminders (if
                                                opted-in)
                                            </li>
                                            <li>Improve user experience on our website</li>
                                        </ul>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Payment Information</h5>
                                        <p>
                                            Bliss Water Technology does not collect or process online
                                            payments through this website. All payments are made
                                            directly to our delivery or installation agent at the time
                                            of product handover or service completion.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Cookies and Tracking</h5>
                                        <p>
                                            Our website uses cookies to track user preferences,
                                            analyze traffic, and optimize performance. You may manage
                                            cookies via your browser settings.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Data Sharing</h5>
                                        <p>
                                            We do not sell or rent your data. Your information may be
                                            shared with trusted personnel such as delivery or service
                                            agents, strictly for fulfilling your order or service
                                            requests, under confidentiality.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Data Security</h5>
                                        <p>
                                            We implement industry-standard security measures to
                                            protect your information. However, no method of data
                                            transmission is fully secure.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Your Rights</h5>
                                        <p>
                                            You can request to review, update, or delete your personal
                                            data by contacting us. We respect your right to privacy
                                            and will respond promptly.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Children's Privacy</h5>
                                        <p>
                                            Our services are intended for adults. We do not knowingly
                                            collect data from children under the age of 13.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Policy Updates</h5>
                                        <p>
                                            We may update this Privacy Policy periodically. Changes
                                            take effect immediately upon publication. Please review
                                            this page regularly.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Contact Us</h5>
                                        <p>
                                            If you have questions or concerns about our privacy
                                            practices, please contact us at{" "}
                                            <a href="mailto:blisswatertechnology@gmail.com">blisswatertechnology@gmail.com</a>{" "}
                                            or call our support team at{" "}
                                            <a href="tel:+919265199516">+91 92651 99516</a>. We're here to help!
                                        </p>
                                    </section>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
